import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from '../../styles/colors';

const SandboxBlockItem = ({item, remove, openBlockDetails}) => {
  return (
    <div style={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        background: COLORS.white,
        height: 55,
        marginTop: 10,
        marginBottom: 10,
        // borderBottom: '1px solid ' + COLORS.grey,
        // borderTop: '1px solid ' + COLORS.grey
      }}>
      <FontAwesomeIcon icon="grip-vertical"
        style={{width: '5%', marginRight: 5, color: COLORS.grey}}/>

      <div style={{width: '85%', textAlign: 'center'}}>
        <b>{item.content}</b>
      </div>


      <FontAwesomeIcon icon="times" className="link"
        onClick={remove}
        style={{width: '5%', color: COLORS.orange}}/>

      <FontAwesomeIcon icon="list" className="link"
        onClick={openBlockDetails}
        style={{width: '5%', color: COLORS.orange}}/>
    </div>
  )
}

export default SandboxBlockItem;



// WEBPACK FOOTER //
// ./src/components/workouts/SandboxBlockItem.js